import * as React from "react";

import MuiSnackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Snackbar({
  t,
  severity,
  open,
  onClose,
  vertical = "bottom",
  horizontal = "center",
  sx,
  message,
}) {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={2000}
      onClose={onClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert onClose={onClose} severity={severity} sx={sx}>
        {t(message)}
      </Alert>
    </MuiSnackbar>
  );
}
